import { render, staticRenderFns } from "./ModalEditarMarca.vue?vue&type=template&id=7c8a42d2"
import script from "./ModalEditarMarca.vue?vue&type=script&lang=js"
export * from "./ModalEditarMarca.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarMarca.vue?vue&type=style&index=0&id=7c8a42d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports